import { Errors } from 'react-redux-form'
import { Translate } from 'react-redux-i18n'

const toMessages = list => list.reduce((acc, key) => {
  acc[key] = <Translate value={`errors.${key}`} />
  return acc;
}, {});

export default ({ messages, ...props }) => (
  <Errors show="touched" messages={toMessages(messages)} className="form-error" {...props} />
);
